<template>
  <div>
    
    <template-breadcrumb />
    <b-container class="self-assesment">
      <b-row>
        <b-col xl="10" offset-xl="1">
          <b-form @submit="onSubmit">
            <b-form-group
              horizontal
              breakpoint="lg"
              :label="$t('label_configuration_user_createAccount_title')"
              label-size="lg"
              label-class="title"
            >
              <b-form-group
                id="name"
                horizontal
                label-class="text-sm-right"
                label-cols="3"
                :label="$t('label_configuration_user_firstName')"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  type="text"
                  required
                />
              </b-form-group>
              <b-form-group
                id="lastName"
                horizontal
                label-class="text-sm-right"
                label-cols="3"
                :label="$t('label_configuration_user_lastName')"
                label-for="lastName"
              >
                <b-form-input
                  id="lastName"
                  v-model="form.lastName"
                  type="text"
                  required
                />
              </b-form-group>
              <b-form-group
                id="email"
                horizontal
                label-class="text-sm-right"
                label-cols="3"
                :label="$t('label_configuration_user_email')"
                label-for="email"
              >
                <b-form-input
                  id="email"
                  v-model="form.email"
                  type="email"
                  required
                />
              </b-form-group>
              <b-form-group
                id="organization"
                horizontal
                label-class="text-sm-right"
                label-cols="3"
                :label="$t('label_configuration_user_organization')"
                label-for="organization"
              >
                <b-form-input
                  id="organization"
                  v-model="form.organization"
                  type="text"
                  required
                />
              </b-form-group>
              <b-form-group
                id="position"
                horizontal
                label-class="text-sm-right"
                label-cols="3"
                :label="$t('label_configuration_user_position')"
                label-for="position"
              >
                <b-form-input
                  id="position"
                  v-model="form.position"
                  type="text"
                  required
                />
              </b-form-group>
              <b-form-group
                id="phone"
                horizontal
                label-class="text-sm-right"
                label-cols="3"
                :label="$t('label_configuration_user_telephone')"
                label-for="phone"
              >
                <b-form-input
                  id="phone"
                  v-model="form.phone"
                  type="number"
                  required
                />
              </b-form-group>
              <b-form-group
                id="accountRoleId"
                horizontal
                label-class="text-sm-right"
                label-cols="3"
                :label="$t('label_configuration_user_roles')"
                label-for="accountRoleId"
              >
                <b-form-select
                  id="accountRoleId"
                  v-model="form.accountRoleId"
                  class="mb-3"
                >
                  <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option value="" disabled>
                      {{ $t("label_selfAssessment_optionList_default") }}
                    </option>
                  </template>
                  <option
                    v-for="(item, key) in accountRoleIdOptions"
                    :key="key"
                  >
                    {{ $t(item.name) }}
                  </option>
                </b-form-select>
              </b-form-group>
              <p class="required">
                {{ $t("label_configuration_user_notice_required") }}
              </p>
              <p>{{ $t("label_configuration_user_notice_registration") }}</p>
              <b-button type="submit" variant="primary" block>
                {{ $t("label_configuration_user_createAccount_button") }}
              </b-button>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "ConfigurationAccessControl",
  data: function () {
    return {
      
      form: {
        accountRoleId: "",
        name: "",
        lastName: "",
        gender: "",
        phone: "",
        position: "",
        realm: "",
        username: "",
        email: "",
        emailVerified: false,
      },
      accountRoleIdOptions: [
        {
          name: "user",
          id: "5ae91dfda136040b3cbfa787",
        },
        {
          name: "fill selfassessment",
          id: "5aec7788335995e716c4c445",
        },
        {
          name: "fill others",
          id: "5aec7791335995e716c4c446",
        },
      ],
    };
  },
  created: function () {},
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
    },
  },
  computed: {
    ...mapGetters({
      business: "getBusiness",
    }),
  },
};
</script>

<style lang="sass" scoped>
@import "../../../assets/css/variables"


p
    text-align: center !important
    width: 60%
    margin: 0 auto

.required
  color: $primary-color

.btn-primary
  width: 60%
  margin: 20px auto
</style>
